function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { BOS, HALIFAX, LLOYDS, MBNA, SCOTTISH_WIDOWS, WHITE_LABEL_DARK, WHITE_LABEL_LIGHT } from "../../constants";
import { useBrand } from "../BrandProvider";
import SvgIcon from "../SvgIcon";
var BosIcon = function BosIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M9-1h6v15.96H9V-1zm3 18c-2.28 0-3 1.08-3 2.88v.24C9 21.8 9.72 23 12 23c2.28 0 3-1.08 3-2.88v-.24c0-1.8-.72-2.88-3-2.88z",
    fill: "currentColor",
    fillRule: "evenodd"
  }));
};
BosIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
var HalifaxIcon = function HalifaxIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.2952567,2.08976805 C10.8130288,1.07222106 11.9959246,0.701022889 12.9373283,1.26067373 C13.2605701,1.45283627 13.5265984,1.74038162 13.7043814,2.08976805 L13.7043814,2.08976805 L22.7588325,19.8839481 C23.2766046,20.9014951 22.9331833,22.1800666 21.9917795,22.7397174 C21.7045557,22.9104678 21.3820705,23 21.0542702,23 L21.0542702,23 L2.94536792,23 C1.87097088,23 1,22.0585827 1,20.8972856 C1,20.542972 1.0828325,20.1944033 1.2408056,19.8839481 L1.2408056,19.8839481 Z M12.0022278,3 L2.9956665,21.0060577 L21.0027924,20.9994812 L12.0022278,3 Z M12,17 C12.5128358,17 12.9355072,17.3827202 12.9932723,17.8826674 L13,18 C13,18.5128358 12.6172798,18.9355072 12.1173326,18.9932723 L12,19 C11.4477153,19 11,18.5561352 11,18 C11,17.4871642 11.3827202,17.0644928 11.8826674,17.0067277 L12,17 Z M13,9 L13,15 L11,15 L11,9 L13,9 Z",
    fill: "currentColor"
  })));
};
HalifaxIcon.defaultProps = {
  width: "24px",
  height: "24px",
  viewBox: "0 0 24 24",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
};
var LloydsIcon = function LloydsIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M15 20.7c0 2.004-.642 3.3-2.98 3.3C9.68 24 9 22.704 9 20.7v-.33c0-2.004.68-3.253 3.02-3.253 2.338 0 2.98 1.249 2.98 3.254v.33zM9.227 0h5.546v5.718l-.454 9.141H9.681l-.454-9.14V0z",
    fill: "currentColor",
    fillRule: "evenodd"
  }));
};
LloydsIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
var MaterialIcon = function MaterialIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M0 22L12 1L24 22H0ZM3 20H21L12 4.55212L3 20ZM12 18.5332C12.271 18.5332 12.4981 18.4416 12.6814 18.2583C12.8647 18.075 12.9563 17.8478 12.9563 17.5769C12.9563 17.3059 12.8647 17.0788 12.6814 16.8955C12.4981 16.7122 12.271 16.6205 12 16.6205C11.729 16.6205 11.5019 16.7122 11.3186 16.8955C11.1353 17.0788 11.0437 17.3059 11.0437 17.5769C11.0437 17.8478 11.1353 18.075 11.3186 18.2583C11.5019 18.4416 11.729 18.5332 12 18.5332ZM11.112 15.4365H12.888V9.51612H11.112V15.4365Z",
    fill: "currentColor"
  }));
};
MaterialIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var MbnaIcon = function MbnaIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M9,21.3630051 C9,19.8944339 10.2023674,18.6929802 11.6716315,18.6929802 C13.1411837,18.6929802 14.3099999,19.8944339 14.3099999,21.3630051 C14.3099999,22.83208 13.1411837,24 11.6716315,24 C10.2022954,24 9,22.8320081 9,21.3630051 Z M11.1706691,16.8902961 L10.1020021,10.7484618 C9.70140497,8.47860972 9.16689147,5.44101033 9.16689147,3.13805635 C9.16689147,1.53549455 9.83496135,0 11.6716315,0 C13.4752546,0 14.1763716,1.53556651 14.1763716,3.13805635 C14.1763716,5.44101033 13.608811,8.47860972 13.2079258,10.7484618 L12.1725939,16.8902961 L11.1706691,16.8902961 L11.1706691,16.8902961 Z"
  }));
};
MbnaIcon.defaultProps = {
  fill: "currentColor",
  fillRule: "evenodd",
  width: "24px",
  height: "24px",
  viewBox: "0 0 24 24",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
};
var ScottishWidowsIcon = function ScottishWidowsIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 11.9997C0 5.37273 5.37232 0 12 0C18.6277 0 24 5.37273 24 12.0003C24 18.6273 18.6277 24 12 24C5.37232 24 0 18.6273 0 11.9997ZM11.7877 14.2827H12.2846C12.6895 14.2827 13.0391 13.9772 13.0575 13.6038L13.4992 7.6789C13.5176 7.30549 13.2048 6 12.7999 6H11.1987C10.8307 6 10.4994 7.27155 10.5178 7.66192L10.9963 13.5699C11.0147 13.9603 11.3828 14.2827 11.7877 14.2827ZM11.9915 18C12.826 18 13.4829 17.3294 13.4829 16.5C13.4829 15.6706 12.826 15.0001 11.9915 15.0001C11.157 15.0001 10.5 15.6706 10.5 16.5C10.5 17.3294 11.157 18 11.9915 18Z",
    fill: "currentColor"
  }));
};
ScottishWidowsIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
import { useTheme } from 'styled-components';
export default function (_ref) {
  var _theme$assets, _theme$assets$icons;
  var rest = _extends({}, _ref);
  var _ref2 = useBrand() || {},
    _ref2$brand = _ref2.brand,
    brand = _ref2$brand === void 0 ? LLOYDS : _ref2$brand;
  var theme = useTheme() || {};
  var svg;
  if ((_theme$assets = theme.assets) !== null && _theme$assets !== void 0 && (_theme$assets$icons = _theme$assets.icons) !== null && _theme$assets$icons !== void 0 && _theme$assets$icons.warning) {
    var _theme$assets2, _theme$assets2$icons;
    svg = (_theme$assets2 = theme.assets) === null || _theme$assets2 === void 0 ? void 0 : (_theme$assets2$icons = _theme$assets2.icons) === null || _theme$assets2$icons === void 0 ? void 0 : _theme$assets2$icons.warning;
  } else {
    switch (brand) {
      case BOS:
        svg = BosIcon;
        break;
      case HALIFAX:
        svg = HalifaxIcon;
        break;
      case LLOYDS:
        svg = LloydsIcon;
        break;
      case MBNA:
        svg = MbnaIcon;
        break;
      case SCOTTISH_WIDOWS:
        svg = ScottishWidowsIcon;
        break;
      case WHITE_LABEL_DARK:
      case WHITE_LABEL_LIGHT:
        svg = MaterialIcon;
        break;
      default:
        // eslint-disable-next-line no-console
        console.warn("Icon is not available in brand \"".concat(brand, "\"."));
        svg = function svg() {
          return null;
        };
    }
  }
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({
    svg: svg
  }, rest));
}